import { X } from 'lucide-react';
import { WelcomeMarkdownRenderer } from './WelcomeMarkdownRenderer';
import { authApi } from '../../api/auth';
import { useAuthStore } from '../../stores/authStore';
import type { WelcomePage } from '../../types';

interface WelcomeModalProps {
  welcomePage: WelcomePage;
  onClose: () => void;
}

export function WelcomeModal({ welcomePage, onClose }: WelcomeModalProps) {
  const { user, setUser } = useAuthStore();

  const handleDismiss = async () => {
    // Update user's lastSeenWelcomeVersion
    if (user) {
      try {
        await authApi.updatePreferences({
          lastSeenWelcomeVersion: welcomePage.version,
        });

        // Update local user state
        setUser({
          ...user,
          preferences: {
            ...user.preferences,
            lastSeenWelcomeVersion: welcomePage.version,
          },
        });
      } catch (err) {
        console.error('Failed to update welcome version:', err);
      }
    }

    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90">
      {/* Modal card */}
      <div className="bg-monster-dark border border-monster-border rounded-lg shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col m-4">

        {/* Sticky header */}
        <div className="flex items-center justify-between p-6 border-b border-monster-border flex-shrink-0">
          <h2 className="text-2xl font-bold text-white">Welcome to Monstervision!</h2>
          <button
            onClick={handleDismiss}
            className="w-12 h-12 flex items-center justify-center rounded-full hover:bg-monster-card transition-colors text-gray-400 hover:text-white"
            title="Close"
          >
            <X size={32} />
          </button>
        </div>

        {/* Scrollable content */}
        <div className="flex-1 overflow-y-auto p-6 scrollbar-dark">
          <WelcomeMarkdownRenderer content={welcomePage.content} />
        </div>

        {/* Sticky footer */}
        <div className="flex items-center justify-end p-6 border-t border-monster-border flex-shrink-0">
          <button
            onClick={handleDismiss}
            className="btn-primary px-8 py-3 text-lg"
          >
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
}
